<template>
  <div id="app">
    <el-container style="min-height:100vh">
      <el-header height="56px">
        <div class="app-header">
          <div style="display:flex;align-items:center;gap:12px;">
            <strong>Account Repo</strong>
            <el-tag type="info" size="mini">Vue2 + Element</el-tag>
          </div>
          <div v-if="username" style="display:flex;align-items:center;gap:8px;">
            <el-tag size="mini" type="success">{{ username }}</el-tag>
            <el-button size="mini" @click="passwordDialogVisible = true">修改密码</el-button>
            <el-button size="mini" type="danger" plain @click="logout">退出登录</el-button>
          </div>
        </div>
      </el-header>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="420px">
      <el-form :model="passwordForm" label-width="90px">
        <el-form-item label="旧密码">
          <el-input v-model="passwordForm.old_password" type="password" show-password />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.new_password" type="password" show-password />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="resettingPassword" @click="resetPassword">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/http'
import { clearAuth, getAuthUsername } from '@/auth'

export default {
  name: 'App',
  data() {
    return {
      username: getAuthUsername(),
      passwordDialogVisible: false,
      resettingPassword: false,
      passwordForm: {
        old_password: '',
        new_password: ''
      }
    }
  },
  created() {
    window.addEventListener('auth-changed', this.syncAuth)
  },
  beforeDestroy() {
    window.removeEventListener('auth-changed', this.syncAuth)
  },
  methods: {
    syncAuth() {
      this.username = getAuthUsername()
    },
    logout() {
      clearAuth()
      if (this.$route.path !== '/login') {
        this.$router.replace('/login')
      }
    },
    async resetPassword() {
      if (!this.passwordForm.old_password || !this.passwordForm.new_password) {
        this.$message.warning('请填写完整密码信息')
        return
      }
      this.resettingPassword = true
      try {
        const { data } = await api.post('/auth/reset-password', this.passwordForm)
        if (data.code === 1) {
          this.$message.success('密码已修改，请重新登录')
          this.passwordDialogVisible = false
          this.passwordForm.old_password = ''
          this.passwordForm.new_password = ''
          this.logout()
          return
        }
        this.$message.error(data.message || '修改失败')
      } catch (e) {
        this.$message.error('网络错误')
      } finally {
        this.resettingPassword = false
      }
    }
  }
}
</script>

<style>
html, body, #app { height: 100%; margin: 0; }
.app-header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
